var _style, _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeVest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1E81F7;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,3v6.9c0,2.4-1.6,4.5-4,5.1l0,0v14h9c2.2,0,4-1.8,4-4V13L10,3H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,3v6.9c0,2.4,1.6,4.5,4,5.1l0,0v14h-9c-2.2,0-4-1.8-4-4V13l6-10H25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,3L10,3c3.8,1.9,8.2,1.9,12,0l0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,25H8c-1.1,0-2-0.9-2-2v-4h7v4C13,24.1,12.1,25,11,25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,25h-3c-1.1,0-2-0.9-2-2v-4h7v4C26,24.1,25.1,25,24,25z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 16,
    x2: 29,
    y2: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3,
    y1: 22,
    x2: 6,
    y2: 22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 22,
    x2: 19,
    y2: 22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26,
    y1: 22,
    x2: 29,
    y2: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeVest);
export default __webpack_public_path__ + "static/media/life_vest.833faeb3f6b8b89b90d8999eb691d61d.svg";
export { ForwardRef as ReactComponent };